import { jsx as i, jsxs as w } from "react/jsx-runtime";
import * as c from "react";
import { STATUS as a } from "../../constants/status.es.js";
import { useStyleConfig as A, chakra as o } from "@chakra-ui/react";
import { AlertIcon as B, MagicIcon as E } from "../../icons/index.es.js";
const D = c.forwardRef(
  ({
    __css: d = {},
    children: n,
    errorText: m = "Try again later",
    leftIcon: u = /* @__PURE__ */ i(E, { boxSize: 4 }),
    loadingText: f = "Gathering data",
    onClick: s,
    rightIcon: g,
    size: h,
    status: e,
    successText: p = "Success",
    trackId: T,
    variant: y,
    ...l
  }, x) => {
    const [r, t] = c.useState(e || a.idle), v = {
      [a.error]: m,
      [a.idle]: n,
      [a.loading]: f,
      [a.success]: p
    }, b = A("SmartDataButtonTheme", {
      variant: y,
      size: h
    }), S = c.useCallback(
      async (j) => {
        try {
          !e && t(a.loading), await (s == null ? void 0 : s(j)), !e && t(a.success);
        } catch {
          !e && t(a.error);
        } finally {
          !e && setTimeout(() => t(a.idle), 5e3);
        }
      },
      [s]
    );
    return c.useEffect(() => {
      t(e || a.idle);
    }, [e]), /* @__PURE__ */ i(
      o.button,
      {
        __css: { ...b, __css: d },
        "data-error": r === a.error ? "" : void 0,
        "data-loading": r === a.loading ? "" : void 0,
        "data-success": r === a.success ? "" : void 0,
        onClick: S,
        ref: x,
        "track-id": T,
        ...l,
        children: /* @__PURE__ */ w(o.div, { "data-content": !0, children: [
          r === a.error ? /* @__PURE__ */ i(B, {}) : u,
          /* @__PURE__ */ i(o.span, { "data-text": !0, children: v[r] }),
          g
        ] })
      }
    );
  }
);
export {
  D as SmartButton
};
//# sourceMappingURL=SmartButton.es.js.map
